<template>
  <div class="skuWrap">
    <div class="price">
      <img :src="skuimg + '?imageView2/1/w/60/h/60'" alt="" />
      {{
       price ? (price == 0 ? '议价' : '￥' +  formatNumer(price)) : sellPrice == 0 ? '议价' : '￥' + formatNumer(sellPrice)
      }}
    </div>
    <div v-for="(item, index) in skuList" :key="index" class="skuitem">
      <div class="skutitle">{{ item.key }}</div>
      <div class="skubtn">
        <span
          v-for="(it, inx) in item.value"
          :class="subIndex[index] == inx ? 'active' : ''"
          @click="specificationBtn(it, index, $event, inx)"
          :key="inx"
          >{{ it }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumer } from '@/utils/index';
export default {
  props: ['data'],
  data() {
    return {
      item: null,
      skuimg: null,
      skuList: null,
      sellPrice: null,
      selectArr: [], //存放被选中的值
      shopItemInfo: {}, //存放要和选中的值进行匹配的数据
      subIndex: [], //是否选中
      price: '', //选中规格的价钱
    };
  },
  created() {
    this.item = this.data;
    this.skuimg = this.item.goodPhotoList[0].imageUrl;
    this.sellPrice = this.data.sellPrice;
    this.init();
  },
  methods: {
    formatNumer,
    init() {
      if (this.data.goodStockKeyValue && this.data.goodStockKeyValue.skuKeyValue) {
        this.skuList = JSON.parse(this.data.goodStockKeyValue.skuKeyValue);
      }
      for (let i in this.item.goodStockList) {
        this.shopItemInfo[this.item.goodStockList[i].propertiesText] = this.item.goodStockList[i];
      }
      if (this.skuList && this.skuList.length) {
        this.checkItem();
      }
    },
    checkItem() {
      let self = this;
      this.skuimg = this.item.goodPhotoList[0].imageUrl;
      let option = JSON.parse(this.data.goodStockKeyValue.skuKeyValue);
      let result = []; //定义数组储存被选中的值
      for (let i in option) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : '';
      }
      for (let i in option) {
        let last = result[i];
        for (let k in option[i].value) {
          result[i] = option[i].value[k];

          self.isMay(result);
        }
        result[i] = last;
      }
      result = JSON.stringify(result);
      if (this.shopItemInfo[result]) {
        this.price = this.shopItemInfo[result].sellPrice || '';
      } else {
        this.price = '';
      }
      if (
        JSON.parse(result).length == this.skuList.length &&
        JSON.parse(result)[JSON.parse(result).length - 1]
      ) {
        this.skuList.map((item, index) => {
          if (item.pic.length > 0) {
            item.pic.map((it, idx) => {
              console.log(it);
              console.log(this.subIndex);
              console.log(this.subIndex[index]);
              if (it && idx == this.subIndex[index]) {
                this.skuimg = it;
              }
            });
          }
        });
      } else {
        this.skuimg = this.item.goodPhotoList[0].imageUrl;
      }
      self.$forceUpdate();
    },
    isMay(result) {
      for (let i in result) {
        if (result[i] == '') {
          return true;
        }
      }
    },
    specificationBtn(item, n, event, index) {
      let self = this;
      if (self.selectArr[n] != item) {
        self.selectArr[n] = item;
        self.subIndex[n] = index;
      } else {
        self.selectArr[n] = '';
        self.subIndex[n] = -1; //去掉选中的颜色
      }
      self.checkItem();
    },
  },
};
</script>
<style lang="less" scoped>
.skuWrap {
  .price {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ff3e3e;
    line-height: 60px;
    img {
      display: inline-block;
      width: 60px;
      height: 60px;
      margin-right: 13px;
      object-fit: contain;
      border: 1px solid #222222;
    }
  }
  .skuitem {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
    .skutitle {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 14px;
      margin-right: 10px;
    }
    .skubtn {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      span {
        display: block;
        min-width: 66px;
        padding: 0 10px;
        height: 28px;
        background: #f1f1f1;
        border: 1px solid #d0d0d0;
        margin-right: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 28px;
        color: #999999;
      }
      span.active {
        border: 1px solid #222222;
        background: #222222;
        color: #ffffff;
      }
    }
  }
}
</style>
